/* eslint-disable @nx/enforce-module-boundaries */
import {
  Box,
  Button,
  Card,
  HStack,
  Heading,
  Stack,
  VStack,
} from '@mybridge/ui';
import { forwardRef, useContext, useEffect, useMemo } from 'react';
import { MyProfileContext } from '../context';
import { useRouter } from 'next/router';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

export const MyProfileEditButtonsGroup = forwardRef(({ ...props }, ref) => {
  const router = useRouter();
  const { t } = useTranslator();
  const {
    introductionDisc,
    experienceDisc,
    profileDisc,
    skillsDisc,
    educationDisc,
    milestonesDisc,
    certificatesDisc,
    userProfileInfo,
    myExperiences,
    mySkills,
    myEducation,
    myMilestones,
    myCertificates,
    refetchMyExperiences,
    refetchMySkills,
    refetchMyEducation,
    refetchMyMilestones,
    refetchMyCertificates,
    refetchMyTestimonials,
    refetchMyAnalytics,
  } = useContext(MyProfileContext);

  useEffect(() => {
    refetchMyExperiences?.();
    refetchMySkills?.();
    refetchMyEducation?.();
    refetchMyMilestones?.();
    refetchMyCertificates?.();
    refetchMyTestimonials?.();
    refetchMyAnalytics?.();
  }, [userProfileInfo]);

  useEffect(() => {
    refetchMyExperiences?.();
    refetchMySkills?.();
    refetchMyEducation?.();
    refetchMyMilestones?.();
    refetchMyCertificates?.();
    refetchMyTestimonials?.();
    refetchMyAnalytics?.();
  }, []);

  // Helper function to handle button clicks
 const handleButtonClick = (discType, disc) => {
  const query = {
    openDisc: discType,
    scrollTo: discType,
  };

  const scrollToElement = () => {
    const el = document.getElementById(discType);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  if (router.pathname === '/profile/about') {
    // Always replace the query params (to update URL)
    router.replace({ pathname: router.pathname, query }, undefined, { shallow: true });

    // Always open the disclosure
    disc?.onOpen?.();

    // Scroll immediately
    setTimeout(() => scrollToElement(), 100);
  } else {
    // Navigate to /profile/about — scroll will be handled in the page useEffect
    router.push({ pathname: '/profile/about', query });
  }
};



  const buttons = useMemo(() => {
    return [
      ...(userProfileInfo?.profile_intro?.length
        ? []
        : [
            {
              title: t('profile.addIntroduction') || 'Add Introduction',
              onClick: () => handleButtonClick('introduction', introductionDisc)
            },
          ]),
      ...(userProfileInfo?.profile_email?.length || userProfileInfo?.email?.length
        ? []
        : [
            {
              title: t('profile.addProfileDetails') || 'Add Profile Details',
              onClick: () => router.push('/profile/about?tab=profileDetails'),
            },
          ]),
      ...(myExperiences?.length
        ? []
        : [
            {
              title: t('profile.addExperience') || 'Add Experience',
              onClick: () => handleButtonClick('experience', experienceDisc)
            },
          ]),
      ...(mySkills?.length
        ? []
        : [
            {
              title: t('profile.addSkills') || 'Add Skills',
              onClick: () => handleButtonClick('skills', skillsDisc)
            },
          ]),
      ...(myEducation?.length
        ? []
        : [
            {
              title: t('profile.addEducation') || 'Add Education',
              onClick: () => handleButtonClick('education', educationDisc)
            },
          ]),
      ...(myMilestones?.length
        ? []
        : [
            {
              title: t('profile.addMilestones') || 'Add Milestones',
              onClick: () => handleButtonClick('milestones', milestonesDisc)
            },
          ]),
      ...(myCertificates?.length
        ? []
        : [
            {
              title: t('profile.certificationsAwards') || 'Certifications & Awards',
              onClick: () => handleButtonClick('certificationsAndAwards', certificatesDisc)
            },
          ]),
      // {
      //   title: 'Testimonials',
      // },
    ];
  }, [
    userProfileInfo,
    myExperiences,
    myCertificates,
    myMilestones,
    myEducation,
    mySkills,
    router.pathname,
    introductionDisc,
    experienceDisc,
    skillsDisc,
    educationDisc,
    milestonesDisc,
    certificatesDisc
  ]);

  
  return (
    <>
      {buttons?.length ? (
          <Card borderRadius="16px"  p={3}  border="1px solid #e0e0e094" w='330px' variant="thinBorderedCard">
          {/* <Heading size="md">Profile</Heading> */}
          <VStack
            justifyContent="center"
            alignItems="center"
            flexWrap="wrap"
            gap={1}
            w="-webkit-fill-available"
          >
            {buttons?.map?.((btn, btnIndex) => (
              <Box key={btnIndex} p={1}>
                <Button
                  fontWeight="500"
                  variant="secondary"
                  fontSize="16px"
                  bg="#E4E6EB"
                  w="300px"
                  onClick={btn.onClick}
                  key={btnIndex}
                  h="48px"
                  color="#3D5A80"
                  borderRadius="56px"
                >
                  {btn.title}
                </Button>
              </Box>
            ))}
          </VStack>
        </Card>
      ) : (
        ''
      )}
    </>
  );
});
